import eHttps from "@/components/tools/request/https-e.js";
import fHttps from "@/components/tools/request/https-f.js";
import utils from '@/components/tools/utils.js';

const state = {
    glId: ''                    // 授课ID
    , tdId: ''                  // 讲义ID
    , pptObj: {}                // 授课ppt内容
    , clsArr: []                // 授课过程的班级以及学生信息
    , teamArr: []               // 小组列表
    , teamArrOrderByStar: []    // 按获得星星数排序的小组列表
    , titleObj: {
        'responder': '抢答',
        'rollcall': '随机点名',
        'group': '分组',
        'student': '学生情况'

    }
    , groupTaskStatusList: []   // 分组任务节点状态
    , taskTeamProcessList: []   // 分组任务小组进度
    , rushAnswerStuArr: []      // 抢答的学生list
    , studentList: []           // 授课时的全部学生列表
    , stuSort: 1                // 学生列表数据排序，1按学号排序，2按照得星数排序
    , flowIconId: ''            // 记录授课悬浮按钮选中的Id, 来控制显示哪个页
    , showGroupTask: false      // 是否显示分组任务,是否显示分组页面e000211
    , sendTaskInfo: {}          // 发送任务信息
    , memoryCourseId:''        //记忆课程id
    , giveLessonsTimeId:''    //记录老师点击授课存入教师行为表id
    , currentPage:0
}

const actions = {
    setAnswerStuArr({ commit }, arr) {
        commit('SET_ANSWER_STU_ARR', arr);
    },
    // 设置学生列表查询的排序
    setQueryStuSort({ commit }, sort) {
        commit('SET_QUERY_STU_SORT', sort);
    },
    // 授课ID和教学设计ID
    setGlIdAndTdId({ commit }, param) {
        commit('SET_GL_ID', param.glId);
        commit('SET_TD_ID', param.tdId);
    },
    getPPTContent({ commit }, glId) {
        return new Promise((resolve, reject) => {
            eHttps.infoPPT({ glId: glId }).then(res => {
                if (utils.requestSuccess(res)) {
                    let sectionArr = [];
                    commit('setGiveLessonsTimeId' ,res.data.givingLessonTimeId);
                    commit('SET_RECORD_PPT_PAGE',res.data.currentPage);
                    if (!utils.isNull(res.data.sectionDtos)) {
                        sectionArr = res.data.sectionDtos;
                        // 格式化CSS（字符串转对象）
                        let secTemp = null;
                        for (let i = 0, j = sectionArr.length; i < j; i++) {
                            secTemp = sectionArr[i];
                            // 判断 当前secTemp中无item 设计背景色 白色
                            if (!utils.isNull(secTemp) && !utils.isEmptyArray(secTemp.items)) {
                                for (let m = 0, n = secTemp.items.length; m < n; m++) {
                                    secTemp.items[m].css = JSON.parse(secTemp.items[m].css);
                                    if (secTemp.items[m].type == '9') {
                                      secTemp.items[m].taccount = JSON.parse(secTemp.items[m].taccount);
                                    }
                                }
                            }
                          secTemp.prop = {};
                          secTemp.prop.bgType = secTemp.bgType;
                          secTemp.prop.bgValue = secTemp.bgValue;
                        }
                    } else {
                      // 页码不能为零
                      var prop={};
                      sectionArr.push(prop);
                      res.data.sectionDtos = sectionArr;
                    }
                    commit('SET_PPT_OBJ', res.data);
                }
            }).then(res => {
                resolve();
            })
        });
    },
    // 获取授课时的学生列表
    listGlStus({ commit, state },glId) {
        return eHttps.listGlStus({ glId: glId, sort: state.stuSort }).then(res => {
            if (utils.requestSuccess(res)) {
                let stuArr = [];
                let cls = null;
                for(let i = 0, j = res.data.length; i < j; i++) {
                    cls = res.data[i];
                    for(let m = 0, n = cls.glStuList.length; m < n; m++) {
                        cls.glStuList[m].attendStatus = null;
                        stuArr.push(cls.glStuList[m]);
                    }
                }
                commit('SET_STUDENT_LIST', stuArr);
                commit('SET_CLS_ARR', res.data);
            }
        });
    },
    listGlTeams({ commit }, glId) {
        return eHttps.listGlTeams({ glId: glId }).then(res => {
            if (res.code == 1) {
                commit('SET_TEAM_ARR', res.data);
                let source = res.data;
                let arr = [];
                source.forEach(res => {arr.push(res)});
                //轮数
                for(var i = 0; i<arr.length-1;i++){
                    //次数
                    for(var j = i;j<arr.length-1-i;j++){
                        //最小的放在最后
                        if(utils.compareTo(arr[j].teamStarNum,arr[j+1].teamStarNum) == -1){
                            // 交换两个变量的值
                            var temp = arr[j];
                            arr[j] = arr[j+1];
                            arr[j+1] = temp;

                        }
                    }
                }
                commit('SET_TEAM_ARR_ORDERBY_STAR', arr);
            }
        })
    },

    setFlowIconId({ commit }, flowIconId) {
        commit('SET_FLOW_ICON_ID', flowIconId);
        if(flowIconId == 'attendance'){
            commit('SET_SHOW_GROUP_TASK', false);
        }
    },
    // 获取分组任务状态
    getGroupTaskStatus({ commit }, param) {
        fHttps.getGroupTaskStatus(param).then(res => {
            if (res.code == 1) {
                commit('SET_GROUP_TASK_STATUS', res.data);
            }
        })
    },
    // 授课页是否显示分组任务
    setShowGroupTask({ commit }, val){
        commit('SET_SHOW_GROUP_TASK', val);
    },
    getTaskTeamProcessList({ commit }, param){
        return new Promise((resolve, reject) => {
            fHttps.getExecStatus(param).then(res => {
                if (utils.requestSuccess(res)) {
                    commit('SET_TASK_TEAM_PROCESS', res.data);
                }
            }).then(res => {
                resolve();
            })
        });
    },
    getSendTaskInfo({ commit },param){
        return new Promise((resolve, reject) => {
            fHttps.getSendTaskByGlIdAndGtId({glId: param.glId, gtId: param.gtId}).then(res => {
                if(utils.requestSuccess(res)){
                    commit('SET_SEND_TASK_INFO', res.data);
                }
            }).then( res => {
                resolve();
            })
        });
    }
}

const mutations = {
    SET_ANSWER_STU_ARR: (state, arr) => {
        state.rushAnswerStuArr = [];
    },
    SET_QUERY_STU_SORT: (state, sort) => {
        state.stuSort = sort;
    },
    SET_MEMORY_COURSE_ID:(state,type) => {
        state.memoryCourseId = type
    },
    SET_FLOW_ICON_ID: (state, flowIconId) => {
        state.flowIconId = flowIconId;
    },
    SET_CLS_ARR: (state, clsArr) => {
        state.clsArr = clsArr;
    },
    SET_TEAM_ARR: (state, arr) => {
        state.teamArr = arr;
    },
    ['SET_GL_ID'](state, val) {
        state.glId = val;
    },
    ['SET_TD_ID'](state, val) {
        state.tdId = val;
    },
    ['SET_GROUP_TASK_STATUS'](state, list) {
        state.groupTaskStatusList = list;
    },
    ['SET_PPT_OBJ'](state, obj) {
        state.pptObj = obj;
    },
    SET_STUDENT_LIST: (state, list) => {
        state.studentList = list;
    },
    // ['SET_RUSH_ANSWER'](state, arr) {
    //     state.rushAnswerStuArr = arr;
    // }
    SET_TEAM_ARR_ORDERBY_STAR: (state, arr) => {
        state.teamArrOrderByStar = arr;
    },
    SET_SHOW_GROUP_TASK: (state, val) => {
        state.showGroupTask = val;
    },
    SET_TASK_TEAM_PROCESS: (state, list) => {
        state.taskTeamProcessList = list;
    },
    SET_SEND_TASK_INFO: (state, obj) => {
        state.sendTaskInfo = obj;
    },
    setGiveLessonsTimeId:(state,value) => {
        state.giveLessonsTimeId = value
    },
    SET_RECORD_PPT_PAGE:(state,value) => {
        state.currentPage = value
    }
}

const getters = {
	getStuSort() {
		return state.stuSort;
	}
}

export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/e000102.js